export default "__VITE_ASSET__BTAV5H55__"